import { useParams, useNavigate } from "react-router-dom";
import platformSolutions from "./platformSolutions";
import "./ProductPage.css";
import { FaArrowRight } from "react-icons/fa";

function ProductPageComponent() {
  const { id } = useParams();
  const navigate = useNavigate();

  const product = platformSolutions.find((p) => p.id === id);

  if (!product) {
    return (
      <div className="pp-popup-overlay">
        <div className="pp-popup-card">
          <button className="pp-close-btn" onClick={() => navigate(-1)}>
            ✕
          </button>
          <p>Product not found.</p>
        </div>
      </div>
    );
  }

  // Helper to handle app click - now navigates to app detail page
  const handleAppClick = (app) => {
    // Generate a unique ID for the app based on its title
    // This ensures we can find it later
    const appId = app.title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    
    // Navigate to app detail page
    navigate(`/product/${product.id}/app/${appId}`);
  };

  return (
    <div className="pp-popup-overlay">
      <div className="pp-popup-card">
        <button className="pp-close-btn" onClick={() => navigate(-1)}>
          ✕
        </button>

        <div className="pp-product-header">
          <h2 className="pp-product-title">{product.title}</h2>
          <p className="pp-product-description">{product.description}</p>
        </div>

        {product.apps && product.apps.length > 0 ? (
          <div className="pp-apps-grid">
            {product.apps.map((app, index) => {
              // Generate consistent app ID
              const appId = app.title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
              // Add ID to app object for later use
              app.id = appId;
              
              return (
                <div
                  className="pp-app-card"
                  key={index}
                  onClick={() => handleAppClick(app)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="pp-app-card-inner">
                    <div className="pp-image-box">
                      <img src={app.image} alt={app.title} />
                    </div>

                    <div className="pp-app-content">
                      <h3>{app.title}</h3>
                      <p>{app.tagline}</p>
                      {/* <div className="pp-app-card-footer">
                        <span className="pp-view-details">View Details</span>
                        <FaArrowRight className="pp-arrow-icon" />
                      </div> */}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="pp-no-apps">No apps available for this product.</p>
        )}
      </div>
    </div>
  );
}

export default ProductPageComponent;